/**
  申し込み用フォーム[SEO・MEO集客最大化パック]コンポーネント
  プラン選択のみ。SEO/MEOの入力は既存フォームを利用する。
*/
<template>
  <div id="formSeoMeoPack" class="form_group">
    <Section class="form_wrap form_list">
      <h1 class="wrap_title pd_7">SEO・MEO集客最大化パック</h1>
      <p class="c-notice">プラン選択後、下に表示される既存のSEO・MEOフォームへ入力してください。</p>

      <Column class="pd3_parts">
        <label>プラン</label>
        <ul class="c-choices">
          <li class="c-choices__item">
            <label class="c-choice">
              <input type="radio" class="required" name="seo_meo_pack_plan" id="seoMeoPackPlanLight" value="ライトプラン" @change="onPlanChange">
              <span>ライトプラン</span>
            </label>
          </li>
          <li class="c-choices__item">
            <label class="c-choice">
              <input type="radio" class="required" name="seo_meo_pack_plan" id="seoMeoPackPlanStandard" value="スタンダードプラン" @change="onPlanChange">
              <span>スタンダードプラン</span>
            </label>
          </li>
          <li class="c-choices__item">
            <label class="c-choice">
              <input type="radio" class="required" name="seo_meo_pack_plan" id="seoMeoPackPlanArea" value="エリア拡大プラン" @change="onPlanChange">
              <span>エリア拡大プラン</span>
            </label>
          </li>
        </ul>
      </Column>
    </Section>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

import Column from '../../../molecules/column.vue';
import Section from '../../../molecules/section.vue';

export default defineComponent({
  name: 'formApplicationSeoMeoPack',

  components: {
    Section,
    Column,
  },

  methods: {
    onPlanChange(event) {
      document.dispatchEvent(new CustomEvent('seoMeoPackPlanChange', {
        detail: event.target.value,
      }))
    },
  },
})
</script>
